export default __webpack_public_path__ + "eeb2e5605f6aed513528d9cc7d344ef1.png";